import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useState } from 'react';
import {
  Button,
  Dropdown,
  Form,
  Menu,
  Modal,
  Select,
  Tab,
} from 'semantic-ui-react';
import { store, useStore } from '../../../app/stores/store';
import { useParams } from 'react-router-dom';
import { optionsInterface } from '../../../app/models/tabverify';
import DashboardTemplateCard from '../../Dashboard/Receiving/CreateOrder/DashboardTemplateCard';
import { Template } from '../../../app/models/template';
import { OrderInitialState, Orders } from '../../../app/models/orders';
import MultipleCSV from './MultipleCSV';
import { ReadFromCSV } from './ReadFromCSV';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { v4 as uuid } from 'uuid';
import LoadingComponent from '../../../app/layout/LoadingComponent';
function SectionsModalMultiple() {
  const {
    activityStore,
    dashboardStore,
    WorkLevelStore,
    TemplateStore,
    mediaAssetStore,
    departmentStore,
    commonStore,
    userStore,
    viewStore: { parentMetadata, metadata },
    TrackingReportStore
  } = useStore();
  const { loadWorkLevelBasedOnItemLevel, selectedWorkLevelItemsForName } =
    WorkLevelStore;
  const { loadDepartments, departmentRegistry, departmentitemsByDate } =
    departmentStore;
  const {
    loadTemplateIdForCR,
    selectedTemplate,
    loadAssetTypeById,
    assetTypesByName,
    selectedAssetType,
  } = TemplateStore;
  const { restorationCutlist } = TrackingReportStore
  const { id } = useParams<{ id: string }>();
  const [elementTypeOptions, setElementTypeOptions] = useState<
    optionsInterface[] | []
  >([]);
  const [selectedAssetTypeId, setSelectedAssetTypeId] = useState<string>(''); //parent selection
  const [orderState, setOrderState] = useState<Orders>(OrderInitialState);
  const [selectedElementTypeId, setSelectedElementTypeId] = useState<string[]>(
    [],
  ); //child selection
  const [element, setElement] = useState<string>('');
  const [typeSearch, setTypeSearch] = useState<string>('');
  const [templateSelected, SetTemplateSelected] = useState<
    Template | undefined
  >(selectedTemplate);
  const [uploadFileDetails, setUploadedFileDetails] = useState<any>();
  const [uploadFileDetails2, setUploadedFileDetails2] = useState<any>([]);
  const [csvUploaded, setCsvUploaded] = useState(false);
  const [departmentSelected, setDepartmentSelected] = useState('');
  const [departmentClear, setDepartmentClear] = useState('');
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedReelName,setSelectedReelName]=useState<string>('');

  //assettypename and elementTypeName
  const [assetTypeName, setAssetTypeName] = useState('');
  const [elementTypeName, setElementTypeName] = useState('');
 const [restorationAssetTypeOption,setRestorationAssetTypeOption] = useState<{
    key: string;
    text: string;
    value: string;
}[]>([])
  const [restorationDeptOption,setRestorationDeptOption] = useState<{
    key: string;
    text: string;
    value: string;
}[]>([]);
  const [restorationTemplateOption,setRestorationTemplateOption] = useState<{
    key: string;
    text: string;
    value: string;
}[]>([]);


const readOnlySelect = {
  pointerEvents: 'none', 
  opacity: '1'
};
const RestorationDropdown = ()=>{
  const assetOption:any = restorationCutlist.assetType.options?.map((asset) => ({
    key: uuid(), // Assuming uuid() generates a unique identifier
    text: asset,
    value: asset
}));

setRestorationAssetTypeOption(assetOption);
setAssetTypeName(restorationCutlist?.assetType?.elementName);
setSelectedAssetTypeId(restorationCutlist?.assetType?.id)
const elementOptions:any = restorationCutlist.elementType.options?.map((element:any)=>({
  key: element?.id,
  text: element?.elementName,
  value: element?.elementName
}))
setElementTypeOptions(elementOptions)
setElementTypeName(restorationCutlist.elementType?.elementName)
setElement(restorationCutlist.elementType?.id)
 const deptOptions = restorationCutlist.department.options?.map((dept)=>({
  key: dept.id,
  text: dept.department_Name,
  value: dept.department_Name
 }))
 setRestorationDeptOption(deptOptions);
 const deptValue = deptOptions.filter((item:any)=> item.value === "Restoration")
 setDepartmentClear(deptValue[0]?.value)
 const templateOptions = restorationCutlist.template.options?.map((temp:any)=>({
  key: temp.templateId,
  text: temp.templateName,
  value: temp.templateName
 }))
 setRestorationTemplateOption(templateOptions)
 setTypeSearch(restorationCutlist?.template?.elementName)
 SetTemplateSelected(restorationCutlist.template.options[0])
}
  useEffect(()=>{
    if(commonStore.RestorationCustomer){
      TrackingReportStore.handleRestorationAssetType(id || '');
    }
    // eslint-disable-next-line
  },[]);
  useEffect(()=>{
    if(commonStore.RestorationCustomer && restorationCutlist.assetType.options.length > 0){
      if(commonStore.RestorationCustomer){
        RestorationDropdown();
        setActiveIndex(1)
      }
    }
    else{
      setRestorationAssetTypeOption([]);
      setElementTypeOptions([])
      setAssetTypeName('');
      setSelectedAssetTypeId('')
     setElementTypeName('')
     setElement('')
     setRestorationDeptOption([]);
     setRestorationTemplateOption([])
     setTypeSearch('')
     SetTemplateSelected(selectedTemplate)
    }
    // eslint-disable-next-line
  },[restorationCutlist])


  useEffect(() => {
    if (id) {
      parentMetadata({ itemId: id });
      loadWorkLevelBasedOnItemLevel(id);
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if(commonStore.RestorationCustomer) return;
    loadAssetTypeById(selectedAssetTypeId);
    TemplateStore.loadElementTypeById(element);
    // eslint-disable-next-line
  }, [selectedAssetTypeId, element]);

  useEffect(() => {
    if(commonStore.RestorationCustomer) return;
    if (departmentRegistry.size <= 1) loadDepartments();
    // eslint-disable-next-line
  }, [departmentRegistry.size, loadDepartments]);

  const handleParentDropdown = (e: any, data: any) => {
    if(commonStore.RestorationCustomer) return;
    setSelectedAssetTypeId(data.value); //parent
    setAssetTypeName(e.target.textContent);
    setTypeSearch('');
    SetTemplateSelected(undefined);
    dashboardStore.updateCreateOrderTemplate(undefined);
    if (e.target.parentElement.text !== undefined) {
      setSelectedElementTypeId(
        selectedElementTypeId.filter(
          (x) => x.split('/')[1] !== e.target.parentElement.text,
        ),
      );
    }
  };

  useEffect(() => {
    if (selectedAssetType) {
      const elementTypeOptions2 = selectedAssetType?.elementTypes.map((x) => ({
        key: x.id,
        text: x.elementName,
        value:
          x.id +
          '/' +
          selectedAssetType.typeName +
          '/' +
          x.elementName +
          '/' +
          selectedAssetType.id,
      }));
      setElementTypeOptions(elementTypeOptions2);
    }
  }, [selectedAssetType]);

  const assetTypeOptions = assetTypesByName?.map((x) => ({
    key: x?.id,
    text: x?.typeName,
    value: x.id,
    // + "/" + x.typeName
  }));

  const filteredTemplate =
    TemplateStore?.selectedElementTypes?.templateTypes.filter((x) =>
      dashboardStore.dashboard.selectedUserRoleId.includes(x.templateId),
    );
  const templateoptions = filteredTemplate?.map((x) => ({
    key: x.templateId,
    text: x.templateName,
    value: x.templateName + '/' + x.templateId,
  }));

  useEffect(() => {
    if (selectedTemplate) {
      SetTemplateSelected(selectedTemplate);
      dashboardStore.updateCreateOrderTemplate(selectedTemplate);
    }
    // eslint-disable-next-line
  }, [selectedTemplate]);

  const handleSelect = (e: SyntheticEvent, data: any) => {
    if(commonStore.RestorationCustomer) return;
    if (data.value === '') {
      setTypeSearch('');
      setOrderState(OrderInitialState);
      SetTemplateSelected(undefined);
      dashboardStore.updateCreateOrderTemplate(undefined);
    } else {
      setTypeSearch(data.value.split('/')[0]);
      loadTemplateIdForCR(data.value.split('/')[1]);
      store.TemplateStore.loadingTemplate = true;
      const oldArr = {
        ...orderState,
        templateId: data.value,
      };
      setOrderState(oldArr);
    }
  };

  const deptSelect = (e: any, data: any) => {
    if (data.name === 'customerId') {
      if (data.value !== '' && e.currentTarget.textContent !== null) {
        dashboardStore.dashboard.createOrderClientId = data.value;
      } else {
      }
    }
    if (data.name === 'departmentId') {
      if (data.value !== '' && e.currentTarget.textContent !== null) {
        dashboardStore.dashboard.createOrderDepartmentId = data.value;
        setDepartmentSelected(e.target.textContent);
        activityStore.sectionOrderDepartmentName = e.target.textContent;
        activityStore.sectionOrderDepartmentId = data.value;
        setDepartmentClear(data.value);
      } else {
        setDepartmentSelected('');
        setDepartmentClear('');
      }
    }
  };

  const filteredDepartment = departmentitemsByDate.filter((x) =>
    dashboardStore.dashboard.selectedUserRoleId.includes(x.id),
  );
  const departmentoptions = filteredDepartment.map((x) => ({
    key: x.id,
    text: x.department_Name,
    value: x.id,
  }));

  const panes = [
    {
      menuItem: 'Template',
      render: () => (
        <Tab.Pane style={{ height: '32vh' }}>
          <Menu>
            <Dropdown
            style={commonStore.RestorationCustomer ? readOnlySelect : {}}
              placeholder="Type"
              fluid
              selection
              options={commonStore.RestorationCustomer ? restorationTemplateOption : templateoptions}
              clearable
              search
              onChange={handleSelect}
              value={typeSearch}
              searchQuery={typeSearch}
            />
          </Menu>
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Customization',
      render: () => (
        <Tab.Pane style={{ height: '32vh' }}>
          <DashboardTemplateCard templateSelected={templateSelected} name={'Sectionmaltiple'}/>
        </Tab.Pane>
      ),
    },
  ];

  const elementDropdownChange = (e: any, data: any) => {
    if(commonStore.RestorationCustomer) return;
    setElement(data?.value?.split('/')[0]);
    setElementTypeName(e.target.textContent);
    setTypeSearch('');
    SetTemplateSelected(undefined);
    dashboardStore.updateCreateOrderTemplate(undefined);
  };

  const FileCallBackFunc = (data: any, metadata: any) => {
    setUploadedFileDetails(data); //this conatins the file from details
  if(commonStore.RestorationCustomer){
   const index = metadata.findIndex((e:any) => e.elementName === 'Reel_Name');
   if(index !== -1) metadata[index].elementValue = selectedReelName;
  }
    setUploadedFileDetails2(metadata);
  };

  const CloseModal = () => {
    mediaAssetStore.setOpenSectionsMultiple(false);
    setTypeSearch('');
    SetTemplateSelected(undefined);
    dashboardStore.updateCreateOrderTemplate(undefined);
    setSelectedAssetTypeId('');
  };
  const getSelectedValue = (options:any, assetTypeName:string) => 
    options.find((option:any) => option.text === assetTypeName)?.value || '';

  return (
    <Modal
      onClose={() => mediaAssetStore.setOpenSectionsMultiple(false)}
      onOpen={() => mediaAssetStore.setOpenSectionsMultiple(true)}
      open={mediaAssetStore.mediaAsset.openSectionMultiple}
    >
      <Modal.Header>
      { TrackingReportStore.restorationCutlist.loading && <LoadingComponent/>}
        {userStore?.user?.customerName === 'Restoration'
          ? 'Import Cutlist'
          : 'Sections Multiple'}
      </Modal.Header>
      <Modal.Content style={{ height: '55vh', overflowY: 'scroll' }}>
        <Form>
          <Form.Group widths="equal">
            <Form.Field
            style={commonStore.RestorationCustomer ? readOnlySelect : {}}
              control={Select}
              name="Type"
              placeholder="Type"
              options={commonStore.RestorationCustomer ? restorationAssetTypeOption : assetTypeOptions}
              onChange={handleParentDropdown}
             value={getSelectedValue(
                commonStore.RestorationCustomer ? restorationAssetTypeOption : assetTypeOptions, 
                assetTypeName
              )}
            />
            <Form.Field
            style={commonStore.RestorationCustomer ? readOnlySelect : {}}
              control={Select}
              name="Element"
              placeholder="Element"
              options={elementTypeOptions}
              onChange={(e:any,data:any)=>{elementDropdownChange(e,data)}}
              value={elementTypeOptions.find(option => option.text === elementTypeName)?.value || ''} 
              readOnly
            />
          </Form.Group>
        </Form>
        <Dropdown
        style={commonStore.RestorationCustomer ? readOnlySelect : {}}
          clearable
          fluid
          search
          required
          selection
          searchQuery={departmentSelected}
          options={commonStore.RestorationCustomer ? restorationDeptOption : departmentoptions}
          name="departmentId"
          value={departmentClear}
          placeholder={
            (
              userLanguage[0].Level3InventoryRecievingCreateOrder
                ?.IRCODD01 as any
            )?.[`${commonStore.language.key}`]
          } //"Select Department"
          onChange={deptSelect}
        />
        <Tab style={{ marginTop: '20px' }} activeIndex={activeIndex} panes={panes} onTabChange={(e, { activeIndex }) => !commonStore.RestorationCustomer && setActiveIndex(activeIndex as number)}/>
        <div>
          {/* activity={activity} Workflow={templateSelected} */}
          <MultipleCSV
            FileCallBackFunc={FileCallBackFunc}
            activity={activityStore.selectedActivity}
            elementTypeID={element}
            setCsvUploaded={setCsvUploaded}
            selectedReelName={selectedReelName}
            setSelectedReelName={setSelectedReelName}
          />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" onClick={CloseModal}>
          Close
        </Button>
        <Button
          primary
          className={selectedReelName === '' && userStore.user?.customerName === 'Restoration' ? 'component-isDisabled' : ''}
          disabled={!csvUploaded}
          onClick={() => {
            ReadFromCSV(
              uploadFileDetails,
              uploadFileDetails2,
              activityStore.selectedActivity,
              commonStore.RestorationCustomer
              ? restorationCutlist.template.options[0]
              : dashboardStore?.dashboard?.CreateOrderTemplate,
              selectedAssetTypeId,
              element,
              assetTypeName,
              elementTypeName,
              selectedWorkLevelItemsForName,
              metadata,
              '',
            );
            CloseModal();
          }}
        >
          Create
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default observer(SectionsModalMultiple);
